import { render, staticRenderFns } from "./ProductParamCreate.vue?vue&type=template&id=de9ce12c&scoped=true"
import script from "./ProductParamCreate.vue?vue&type=script&lang=js"
export * from "./ProductParamCreate.vue?vue&type=script&lang=js"
import style0 from "./ProductParamCreate.vue?vue&type=style&index=0&id=de9ce12c&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9ce12c",
  null
  
)

export default component.exports